module.exports = __webpack_public_path__ + "static/chicory-90d2bfc0793a0a8eca9fafbce9a7e2c6.png";